var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4094_35230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00051 31.8732C4.70932 31.8732 4.47363 31.6372 4.47363 31.3464V0.787617C4.47363 0.496431 4.70932 0.260742 5.00051 0.260742C5.29169 0.260742 5.52738 0.496431 5.52738 0.787617V31.3464C5.52738 31.6372 5.29134 31.8732 5.00051 31.8732Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9372 28.252H1.37844C1.08725 28.252 0.851562 28.016 0.851562 27.7251C0.851562 27.4343 1.08725 27.1982 1.37844 27.1982H31.9372C32.228 27.1982 32.4641 27.4343 32.4641 27.7251C32.4641 28.016 32.228 28.252 31.9372 28.252Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04004 19.5451C7.85985 19.5451 7.68423 19.4527 7.58623 19.2866C7.438 19.0358 7.5209 18.713 7.77169 18.5648L28.0448 6.57908C28.2963 6.43156 28.6191 6.51375 28.7666 6.76454C28.9148 7.01498 28.8319 7.33813 28.5815 7.48601L8.3077 19.4717C8.22375 19.5212 8.13137 19.5451 8.04004 19.5451Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4352 10.9773C27.392 10.9773 27.3477 10.9716 27.3038 10.9604C27.0218 10.8881 26.8521 10.6011 26.9245 10.319L27.6719 7.40997L24.7632 6.66251C24.4812 6.59016 24.3115 6.30319 24.3839 6.02113C24.4562 5.73943 24.7429 5.56907 25.0253 5.64178L28.4443 6.52026C28.7264 6.59262 28.896 6.87959 28.8237 7.16164L27.9452 10.5807C27.8841 10.8192 27.6698 10.9773 27.4352 10.9773Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0995 23.792H7.88833C7.63087 23.792 7.42188 24.0006 7.42188 24.2585V27.9845H11.5659V24.2585C11.5659 24.0006 11.3569 23.792 11.0995 23.792Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0418 20.3232H13.8307C13.5733 20.3232 13.3643 20.5319 13.3643 20.7897V27.9882H17.5083V20.7894C17.5083 20.5319 17.2997 20.3232 17.0418 20.3232Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9823 16.8496H19.7711C19.5137 16.8496 19.3047 17.0583 19.3047 17.3161V27.9874H23.4487V17.3161C23.4484 17.0586 23.2397 16.8496 22.9823 16.8496Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9247 13.375H25.7135C25.4561 13.375 25.2471 13.5836 25.2471 13.8415V27.9852H29.3911V13.8415C29.3911 13.5836 29.1821 13.375 28.9247 13.375Z",
    fill: "#2A5578"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4094_35230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.9c07fb93f1477dc7c7852bf56ea31228.svg";
export { ForwardRef as ReactComponent };